import { UiControl } from './ui-control.model';

export class ToggleControl extends UiControl<boolean | undefined | null> {

  constructor(id: string, label: string, value: boolean | undefined | null) {
    super(id, label, value, false);
    this.className = "ToggleControl";
  }

}
